import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BookingSuccess.css";

const BookingSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data passed from BookingStatus
  const statusData = location.state?.statusData || {};
  const bookingId = location.state?.bookingId || "N/A";
  const amountPaise = statusData?.amount || 0;
  const amount = `₹${(amountPaise / 100).toLocaleString("en-IN")}`;
  const orderId = statusData?.orderId || statusData?.merchantOrderId || bookingId;

  return (
    <div className="success-wrapper">
      <div className="success-card">
        <div className="success-icon-wrap">
          {/* Your SVG Icon */}
          <svg className="success-svg" viewBox="0 0 52 52" fill="none">
            <circle className="success-circle" cx="26" cy="26" r="24" />
            <path className="success-check" d="M14 27l8 8 16-16" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 className="success-heading">Booking Confirmed!</h1>
        <p className="success-subtext">Payment received successfully.</p>

        <div className="success-details-box">
          <div className="detail-row">
            <span className="detail-label">Order ID</span>
            <span className="detail-val">{orderId}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Amount Paid</span>
            <span className="detail-val success-green">{amount}</span>
          </div>
        </div>

        <div className="success-actions">
          <button className="success-btn success-btn--primary" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;